import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "TimeZoneTravelNotification" */ './lazyIndex'),
    { name: 'TimeZoneTravelNotification' }
);

export const TimeZoneTravelNotification: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.TimeZoneTravelNotification
);
